module.exports = __webpack_public_path__ + "media/eye-opened.4deb657c.svg";